import {
  BET_SLIP_DB_NAME,
  BET_SLIP_RECORD_ID,
  BET_SLIP_STORE_NAME,
} from './betSlipConfig';

export interface StoredRecord {
  id: string;
  primary: CryptoKey;
  referenceText: string;
  createdAt: number;
}

const openDb = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('unavailable'));
      return;
    }
    const request = indexedDB.open(BET_SLIP_DB_NAME, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(BET_SLIP_STORE_NAME)) {
        db.createObjectStore(BET_SLIP_STORE_NAME, { keyPath: 'id' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error('open'));
    request.onblocked = () => reject(new Error('blocked'));
  });

export const readRecord = async (): Promise<StoredRecord | null> => {
  const db = await openDb();
  try {
    return await new Promise<StoredRecord | null>((resolve, reject) => {
      const tx = db.transaction(BET_SLIP_STORE_NAME, 'readonly');
      const store = tx.objectStore(BET_SLIP_STORE_NAME);
      const request = store.get(BET_SLIP_RECORD_ID);
      request.onsuccess = () => {
        const result = request.result as StoredRecord | undefined;
        resolve(result ?? null);
      };
      request.onerror = () => reject(request.error ?? new Error('read'));
    });
  } finally {
    db.close();
  }
};

export const writeRecord = async (
  record: Omit<StoredRecord, 'id'>
): Promise<void> => {
  const db = await openDb();
  try {
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(BET_SLIP_STORE_NAME, 'readwrite');
      const store = tx.objectStore(BET_SLIP_STORE_NAME);
      const request = store.put({ ...record, id: BET_SLIP_RECORD_ID });
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error ?? new Error('write'));
    });
  } finally {
    db.close();
  }
};
